import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { appAxios } from "../../../axios/axios";
import { components } from "react-select";
import { SelectWrapper } from "./SelectWrapper";

export const DBCitySearchReturnDetails: React.FC<{
  value: string | undefined;
  onChange: (val: any) => void;
  error?: string;
}> = (props) => {
  const [citiesState, setCitiesState] = React.useState<
    Array<{
      label: string;
      value: any;
    }>
  >([]);

  const [cityInputValue, setCityInputValue] = useState("");

  const getCities = async (city: string) => {
    if (city === "") {
      setCitiesState([]);
      return;
    }

    try {
      const citiesList = await appAxios({
        url: "/api/master/dbCities",
        method: "GET",
        params: {
          city: city,
        },
      });
      setCitiesState(
        citiesList.data.result.map((accomodation) => ({
          label: `${accomodation.city}, ${accomodation.country}`,
          value: `${accomodation.city}, ${accomodation.country}`,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCities(cityInputValue);
  }, [cityInputValue]);

  useEffect(() => {
    if (props.value && !cityInputValue) {
      setCityInputValue(props.value.split(",")[0]);
    }
  }, [props.value]);

  return (
    <div>
      <SelectWrapper
        options={citiesState}
        value={props.value}
        onChange={
          props.onChange
            ? (val: any) => {
                props.onChange && props.onChange(val);
              }
            : (val) => {}
        }
        onInputChange={(val) => {
          if (val.length === 0) {
            return;
          }
          setCityInputValue(val);
        }}
        placeholder="enter city name.."
      />
      <Form.Control.Feedback type="invalid">
        {props?.error}
      </Form.Control.Feedback>
    </div>
  );
};

{
  /* <Select
        onInputChange={(val) => {
          setCityInputValue(val);
        }}
        onChange={(val) => {
          if (props.onSelect && val) {
            props.onSelect(val);
          }
        }}
        placeholder="Search Cities"
        options={citiesState}
        components={{
          Control: (cProps) => (
            <components.Control
              {...cProps}
              // {...(props.controlProps ? props.controlProps : {})}
              className={`${cProps.className} ${props.controlClassName}`}
            />
          ),
        }}
      /> */
}
